import type { ComponentProps } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import SingleDate from './SingleDate';
import { asOfDateShortcuts, earliestAsOfDate } from './asOfDate';

type AsOfDatePickerProps = Omit<
  ComponentProps<typeof SingleDate>,
  'shortcuts' | 'minDate'
>;

/**
 * A single as-of date: the day balances, holdings or allocations are shown
 * for, as legacy's historical picker (`Shared/Components/Historical/
 * DatePicker.jsx`) offered it. The presets are Today, Last Quarter and Last
 * Year, each the last day of its period, and nothing earlier than the start
 * of the month three months back can be picked, since stored history does
 * not reach further and an earlier day shows no accounts.
 */
export default function AsOfDatePicker(props: AsOfDatePickerProps) {
  const { t } = useLocalization();
  return (
    <SingleDate
      {...props}
      shortcuts={asOfDateShortcuts(t)}
      minDate={earliestAsOfDate()}
    />
  );
}
